<div class="row row-nowrap row-centered" [style.textAlign]="'left'">
    <div class="col-auto">
        <rh-user-single [user]="option" [fetchPhoto]="false"></rh-user-single>
    </div>
    <div class="col">
        <span [innerHTML]="(option.name || option.firstName + ' ' + option.lastName) + ' (' + option.email + ')' | highlight:highlightPhrase"></span>
    </div>
</div>